import React, { Fragment } from 'react';
import InputField from '../../Reusable/InputField';
import withTranslations from '../../../utils/HighOrderComponent';
import { Row, Col, Card } from 'react-bootstrap';
import ModalForAddDecision from '../../Decision/ModalForAddDecision';
import { confirmDialog } from '../../Reusable/ConfirmDialog';
import ModalForRequestForSignetApprovalUpdateAndPreview from '../ModalForRequestForSignetApprovalUpdateAndPreview';
import {
  findRequestForSignetApprovalById,
  addProcessorRequestForSignetApproval,
  createRequestForSignetApproval,
  findAllRequestForSignetApprovalAttachments,
  downloadAttachment,
  downloadProposalSolution,
  changeRequestForSignetApprovalStatus,
  deleteErrorRequestForSignetApproval,
  downloadRequest,
  updateRequestClient,
} from '../../../actions/requestForSignetApproval';
import {
  createComplementRequestApproval,
  findLastComplementRequestApprovalByRequestId,
  clearComplementRequestApproval,
  findAllComplementRequestsByRequestId,
} from '../../../actions/complementRequestApproval';
import {
  actionsRequestForSignetApproval,
  controllerPath,
  notificationTypeSuccess,
  decisionStatuses,
  requestForSignetApprovalStatuses,
  userRoles,
} from '../../../constants/globals';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import GetAppIcon from '@material-ui/icons/GetApp';
import NoteAddIcon from '@material-ui/icons/NoteAdd';
import BackupIcon from '@material-ui/icons/Backup';
import DoneOutlineIcon from '@material-ui/icons/DoneOutline';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import DoneIcon from '@material-ui/icons/Done';
import SendIcon from '@material-ui/icons/Send';
import HistoryRoundedIcon from '@material-ui/icons/HistoryRounded';
import AssignmentLateOutlinedIcon from '@material-ui/icons/AssignmentLateOutlined';
import { connect } from 'react-redux';
import { createDecision, deleteErrorDecision } from '../../../actions/decision';
import { findAllDecisionTypes } from '../../../actions/decisionType';
import AttachmentTable from '../../Reusable/AttachmentTable/AttachmentTable';
import ModalForAddComplementRequestApproval from '../ModalForAddComplementRequestApproval';
import ModalForCreateRequestApprovalReferenceNumber from '../ModalForCreateRequestApprovalReferenceNumber';
import ModalForUpdateRequestApprovalReferenceNumber from '../ModalForUpdateRequestApprovalReferenceNumber';
import ModalForViewComplementRequestHistory from '../ModalForViewComplementRequestHistory.js';
import { createRequestForSignetApprovalReferenceNumber } from '../../../actions/requestForSignetApproval';
import {
  findAllUserAllowedActions,
  findAllUsersByKJSMunicipality,
  removeUserList,
} from '../../../actions/user';
import authorizationService from '../../../securityUtils/authorizationService';
import {
  createDecisionWithAttachment,
  findDecisionByRequestId,
  changeDecisionStatusWithStatus,
  sendDecisionToRobon,
} from '../../../actions/decision';
import {
  findDecisionAttachmentByDecision,
  downloadDecisionAttachment,
} from '../../../actions/decisionAttachment';
import {
  checkForUserRole,
  createNotification,
  formatDate,
} from '../../../utils';
import { autonomousProvinces } from '../../../constants/globals';
import CloudDownloadOutlinedIcon from '@material-ui/icons/CloudDownloadOutlined';
import SyncIcon from '@material-ui/icons/Sync';
import ActionButton from '../../Reusable/ActionButton';
import ModalForUpdateRequestCreator from '../ModalForUpdateRequestCreator';

class RequestForSignetApprovalProcessingView extends React.Component {
  constructor() {
    super();
    this.state = {
      showUpdate: false,
      showDecisionCreation: false,
      showComplementRequest: false,
      showAddAttachment: false,
      showCreateReferenceNumber: false,
      showCreateDecisionWithAttachment: false,
      showUpdateReferenceNumber: false,
      showComplementRequestDesc: false,
      showComplementRequestHistory: false,
      modalIsOpened: false,
      showUpdateOfRequestCreator: false,
    };
  }

  componentDidMount() {
    let idRequestForSignetApproval;
    if (!this.props.isPreview)
      idRequestForSignetApproval = this.props.match.params?.id;
    else {
      idRequestForSignetApproval = this.props.id;
    }
    this.props.findRequestForSignetApprovalById(idRequestForSignetApproval);
    this.props.findAllDecisionTypes();
    this.props.findAllRequestForSignetApprovalAttachments(
      idRequestForSignetApproval
    );
    !this.props.isPreview && this.handleGetUserActions();
    this.props.findDecisionByRequestId(idRequestForSignetApproval);
    this.props.decision?.id &&
      this.props.findDecisionAttachmentByDecision(this.props.decision?.id);
    this.props.findAllComplementRequestsByRequestId(idRequestForSignetApproval);
  }

  showModal = (signal) => {
    switch (signal) {
      case 1:
        this.setState({
          showUpdate: true,
        });
        break;
      case 2:
        this.setState({
          showDecisionCreation: true,
        });
        break;
      case 3:
        this.setState({ showComplementRequest: true });
        break;
      case 4:
        this.setState({ showAddAttachment: true });
        break;
      case 5:
        this.setState({ showCreateReferenceNumber: true });
        break;
      case 6:
        this.setState({ showCreateDecisionWithAttachment: true });
        break;
      case 7:
        this.setState({ showUpdateReferenceNumber: true });
        break;
      case 8:
        this.setState({ showComplementRequestDesc: true });
        break;
      case 9:
        this.setState({ showComplementRequestHistory: true });
        break;
      case 10:
        const requestKJSMunicipalityId =
          this.props.requestForSignetApproval?.requestForSignetApproval
            ?.kjsMunicipality?.id;
        this.props.findAllUsersByKJSMunicipality(requestKJSMunicipalityId);
        this.setState({ showUpdateOfRequestCreator: true });
        break;
      default:
        break;
    }
    this.isModalOpened(true);
  };

  addProcessorRequest = () => {
    const { requestForSignetApproval } = this.props;
    const translation = this.props.t.ConfirmDialog;
    const messages = this.props.t.NotificationMessages;
    const action = () => {
      this.props.addProcessorRequestForSignetApproval(
        requestForSignetApproval?.requestForSignetApproval?.id,
        this.handleGetUserActions,
        messages
      );
    };

    confirmDialog(
      translation.confirmMessageProcessor,
      action,
      translation.confirmDeleteProcessor,
      this.props.gt
    );
  };

  handleRequestStatusChange = async (status, confirmMessage, confirmDelete) => {
    const { requestForSignetApproval, t } = this.props;
    const messages = t.NotificationMessages;
    const action = () => {
      this.props.changeRequestForSignetApprovalStatus(
        requestForSignetApproval?.requestForSignetApproval?.id,
        status,
        this.handleGetUserActions,
        messages
      );
    };
    confirmDialog(confirmMessage, action, confirmDelete, this.props.gt);
  };

  acceptEdit = () => {
    const { requestForSignetApproval, t } = this.props;
    const translation = t.ConfirmDialog;
    const messages = t.NotificationMessages;
    const action = () => {
      this.props.changeRequestForSignetApprovalStatus(
        requestForSignetApproval?.requestForSignetApproval?.id,
        requestForSignetApprovalStatuses.COMPLEMENTED.name,
        this.handleGetUserActions,
        messages
      );
    };

    confirmDialog(
      translation.confirmMessageFinishUpdate,
      action,
      translation.confirmDelete,
      this.props.gt
    );
  };

  handleGetUserActions = () => {
    let idRequestForSignetApproval;
    if (!this.props.isPreview)
      idRequestForSignetApproval = this.props.match.params?.id;
    else {
      idRequestForSignetApproval = this.props.id;
    }
    this.props.findAllUserAllowedActions(
      idRequestForSignetApproval,
      controllerPath.REQUEST_FOR_SIGNET_APPROVAL
    );
  };

  isModalOpened = (show) => {
    this.setState({ modalIsOpened: show ? true : false });
  };

  handleAdd = (requestForSignetApproval, status) => {
    const messages = this.props.t.NotificationMessages;
    const addOrDraft =
      status === requestForSignetApprovalStatuses.SUBMIT.name
        ? messages.successSubmittedRequest
        : status === requestForSignetApprovalStatuses.IN_PREPARATION.name
        ? messages.draftSuccess
        : messages.saveSuccessUpdate;
    this.props.createRequestForSignetApproval(
      requestForSignetApproval,
      this.handlePreviewClose,
      () =>
        createNotification(
          notificationTypeSuccess,
          messages.requestTitle,
          addOrDraft
        ),
      messages
    );
  };

  handleAddDecision = (decision) => {
    const messages = this.props.t.NotificationMessages;
    this.props.createDecision(decision, this.handlePreviewClose, messages);
    this.showServerError(this.state.showDecisionCreation);
  };

  showServerError = (isModalOpened) => {
    return isModalOpened ? false : true;
  };

  handleAddComplementRequestApproval = (complementRequestApproval) => {
    const messages = this.props.t.NotificationMessages;
    this.props.createComplementRequestApproval(
      complementRequestApproval,
      this.handlePreviewClose,
      messages
    );
    this.showServerError(this.state.showComplementRequest);
  };

  handleCreateRequestApprovalReferenceNumber = (
    requestWithNewReferenceNumber
  ) => {
    const {
      t,
      requestForSignetApproval,
      createRequestForSignetApprovalReferenceNumber,
    } = this.props || {};
    const messages = t.NotificationMessages;
    const updateOrCreate = requestForSignetApproval.requestForSignetApproval
      .referenceNumber
      ? messages.successReferenceNumberUpdate
      : messages.successReferenceNumber;
    createRequestForSignetApprovalReferenceNumber(
      requestWithNewReferenceNumber.requestForSignetApproval.id,
      requestWithNewReferenceNumber.referenceNumber,
      this.handlePreviewClose,
      () =>
        createNotification(
          notificationTypeSuccess,
          messages.requestTitle,
          updateOrCreate
        ),
      messages
    );
    this.showServerError(this.state.showCreateReferenceNumber);
  };

  handlePreviewClose = () => {
    let idRequestForSignetApproval;
    if (!this.props.isPreview)
      idRequestForSignetApproval = this.props.match.params?.id;
    else {
      idRequestForSignetApproval = this.props.id;
    }
    this.setState({
      showUpdate: false,
      showDecisionCreation: false,
      showComplementRequest: false,
      showCreateReferenceNumber: false,
      showCreateDecisionWithAttachment: false,
      showUpdateReferenceNumber: false,
      showComplementRequestDesc: false,
      showComplementRequestHistory: false,
      showUpdateOfRequestCreator: false,
    });
    this.props.deleteErrorRequestForSignetApproval();
    this.props.deleteErrorDecision();
    this.handleGetUserActions();
    this.props.findAllRequestForSignetApprovalAttachments(
      idRequestForSignetApproval
    );
    this.props.findRequestForSignetApprovalById(idRequestForSignetApproval);
    this.props.clearComplementRequestApproval();
    this.props.removeUserList();
    this.isModalOpened(false);
  };

  downloadProposedSolutiоn = () => {
    const messages = this.props.t.NotificationMessages;
    this.props.downloadProposalSolution(
      this.props.requestForSignetApproval?.requestForSignetApproval,
      messages
    );
  };

  handleDownloadRequest = () => {
    const messages = this.props.t.NotificationMessages;
    const { id } = this.props.match.params;
    this.props.downloadRequest(id, messages);
  };

  handleAddDecisionWithAttachment = (decision) => {
    const messages = this.props.t.NotificationMessages;
    this.props.createDecisionWithAttachment(
      decision,
      this.props.requestForSignetApproval?.requestForSignetApproval?.id,
      this.handlePreviewClose,
      messages
    );
  };

  downloadDecision = () => {
    const { isPreview, t, decisionAttachment, downloadDecisionAttachment } =
      this.props || {};
    const messages = t.NotificationMessages;
    const { embeddableAttribute } = decisionAttachment || {};
    const { uuidName, name } = embeddableAttribute;

    downloadDecisionAttachment(uuidName, name, !isPreview && messages);
  };

  handleDecisionStatusChange = (status, question, altAnswer) => {
    const { t, gt, decision, changeDecisionStatusWithStatus } =
      this.props || {};
    const action = () => {
      changeDecisionStatusWithStatus(
        decision?.id,
        status,
        this.handleGetUserActions,
        t.NotificationMessages
      );
    };
    confirmDialog(question, action, altAnswer, gt);
  };

  handleSendDecisionToRobon = (question, altAnswer) => {
    const { t, gt, decision, sendDecisionToRobon } = this.props || {};
    const action = () => {
      sendDecisionToRobon(
        decision?.id,
        this.handleGetUserActions,
        t.NotificationMessages
      );
    };

    confirmDialog(question, action, altAnswer, gt);
  };

  acceptRequest = () => {
    const { ConfirmDialog } = this.props.t || {};
    this.handleRequestStatusChange(
      requestForSignetApprovalStatuses.ACCEPTED.name,
      ConfirmDialog.confirmMessage,
      ConfirmDialog.confirmDelete
    );
  };

  handleStatusRevert = () => {
    const { t, decision } = this.props || {},
      { ConfirmDialog } = t || {};

    if (decision?.id) {
      this.handleDecisionStatusChange(
        decisionStatuses.IN_PREPARATION.text,
        ConfirmDialog.confirmRevertDecisionStatusMessage,
        ''
      );
    } else {
      this.handleRequestStatusChange(
        requestForSignetApprovalStatuses.IN_PROCESSING.name,
        ConfirmDialog.confirmRevertRequestStatusMessage,
        ''
      );
    }
  };

  requestCreatorUpdateSubmit = (requestForUpdate) => {
    const {
        requestForSignetApproval,
        t,
        updateRequestClient,
        findAllComplementRequestsByRequestId,
      } = this.props || {},
      { requestForSignetApproval: requestForSignetApprovalObj } =
        requestForSignetApproval || {},
      { ConfirmDialog, NotificationMessages } = t || {};

    const action = () => {
      updateRequestClient(
        requestForUpdate,
        this.handlePreviewClose,
        NotificationMessages,
        () =>
          findAllComplementRequestsByRequestId(requestForSignetApprovalObj?.id)
      );
    };
    confirmDialog(
      ConfirmDialog.confirmRequestCreatorChange,
      action,
      '',
      this.props.gt
    );
  };

  render() {
    const {
      enums,
      t,
      decision,
      deleteErrorRequestForSignetApproval,
      findAllDecisionTypes,
      decisionTypeList,
      errorDecision,
      requestForSignetApprovalAttachmentList,
      downloadAttachment,
      createComplementRequestApproval,
      createRequestForSignetApprovalReferenceNumber,
      userAllowedActionsList,
      isPreview,
      complementRequestApprovalList,
      userList,
      errorComplement,
    } = this.props || {};
    const { error, requestForSignetApproval } =
        this.props.requestForSignetApproval,
      {
        createdAt,
        kjsMunicipality,
        note,
        referenceNumber,
        organizationalUnit,
        organizationalUnit2,
        organizationalUnit3,
        elSignet,
        numberOfSignets,
        coatOfArmsAppearance,
        nationalMinorities,
        submitDate,
        client,
      } = requestForSignetApproval || {},
      { kjs, municipality } = kjsMunicipality || {},
      { uniqueNumber, pib, identificationNumber } = kjs || {},
      { place } = municipality || {},
      { Placeholders, Tooltips, ConfirmDialog } = t || {};
    const { Status, CoatOfArmsAppearance, DecisionStatus, NationalMinorities } =
      enums || {};

    const { loggedUser, allowedActions } = this.props.loggedUser || {},
      { items: allowedActionsList } = allowedActions || [];

    const nationalMinoritiesTranslate = nationalMinorities?.map(
      (nationalMinority) => NationalMinorities[nationalMinority].text
    );

    const submitDateFormat = submitDate ? formatDate(submitDate) : createdAt;

    const status = Status[requestForSignetApproval?.status]?.text;
    const decisionStatus = DecisionStatus[decision?.decisionStatus]?.text;

    const isElSignetText = elSignet ? 'Електронски' : '';
    const coatOfArmsAppearanceText =
      CoatOfArmsAppearance[coatOfArmsAppearance]?.text;

    let fullOrganizationUnit = '';
    if (organizationalUnit) fullOrganizationUnit += organizationalUnit;
    if (organizationalUnit2) {
      let comma = '';
      if (organizationalUnit) comma = ', ';
      fullOrganizationUnit += comma + organizationalUnit2;
    }
    if (organizationalUnit3) {
      let comma = '';
      if (organizationalUnit || organizationalUnit2) comma = ', ';
      fullOrganizationUnit += comma + organizationalUnit3;
    }

    const isActionUpdateAllowed = authorizationService.isActionAllowed(
      actionsRequestForSignetApproval.REQUEST_FOR_SIGNET_APPROVAL_UPDATE,
      userAllowedActionsList
    );

    const isActionRequestComplementationAllowed =
      authorizationService.isActionAllowed(
        actionsRequestForSignetApproval.COMPLEMENT_REQUEST_APPROVAL_CREATE,
        userAllowedActionsList
      ) &&
      !checkForUserRole(loggedUser.roles, userRoles.AUTHORIZED_PERSON.value);

    const isActionAddProcessorAllowed = authorizationService.isActionAllowed(
      actionsRequestForSignetApproval.ADD_PROCESSOR,
      userAllowedActionsList
    );

    const isActionAcceptAllowed = authorizationService.isActionAllowed(
      actionsRequestForSignetApproval.ACCEPT_REQUEST_FOR_SIGNET_APPROVAL,
      userAllowedActionsList
    );

    const isReferenceNumberAllowed = authorizationService.isActionAllowed(
      actionsRequestForSignetApproval.ADD_REFERENCE_NUMBER,
      userAllowedActionsList
    );

    const isDecisionViewAllowed = authorizationService.isActionAllowed(
      actionsRequestForSignetApproval.VIEW_DECISION_ACTIONS,
      userAllowedActionsList
    );

    const isDecisionAcceptAllowed = authorizationService.isActionAllowed(
      actionsRequestForSignetApproval.SIGN_DECISION,
      userAllowedActionsList
    );

    const isDecisionUploadAllowed = authorizationService.isActionAllowed(
      actionsRequestForSignetApproval.DECISION_ATTACHMENT_CREATE,
      userAllowedActionsList
    );

    const isDecisionSentAllowed = authorizationService.isActionAllowed(
      actionsRequestForSignetApproval.SENT_DECISION,
      userAllowedActionsList
    );

    const isDecisionDownloadAllowed = authorizationService.isActionAllowed(
      actionsRequestForSignetApproval.DOWNLOAD_DECISION,
      userAllowedActionsList
    );

    const isRequestDownloadAllowed = authorizationService.isActionAllowed(
      actionsRequestForSignetApproval.DOWNLOAD_REQUEST,
      userAllowedActionsList
    );

    const isComplementationContentAllowed =
      authorizationService.isActionAllowed(
        actionsRequestForSignetApproval.COMPLEMENT_REQUEST_CONTENT,
        userAllowedActionsList
      );

    const isStatusRevertAllowed =
      authorizationService.isActionAllowed(
        actionsRequestForSignetApproval.REQUEST_FOR_SIGNET_APPROVAL_STATUS_REVERT,
        userAllowedActionsList
      ) ||
      authorizationService.isActionAllowed(
        actionsRequestForSignetApproval.DECISION_STATUS_REVERT,
        userAllowedActionsList
      );

    const isActionUpdateRequestCreatorAllowed =
      authorizationService.isActionAllowed(
        actionsRequestForSignetApproval.UPDATE_REQUEST_CLIENT,
        allowedActionsList
      ) &&
      (client?.id === loggedUser?.id ||
        authorizationService.canAccessAdminPanel(loggedUser));

    let signalForDownloadDecision;

    if (isPreview) {
      const processorId = requestForSignetApproval?.processor?.id;
      const clientId = requestForSignetApproval?.client?.id;

      if (processorId === loggedUser.id) {
        signalForDownloadDecision = true;
      } else if (clientId === loggedUser?.id) {
        signalForDownloadDecision =
          decision?.decisionStatus === decisionStatuses.SENT?.text;
      } else if (
        checkForUserRole(loggedUser.roles, userRoles.INSPECTOR.value)
      ) {
        signalForDownloadDecision = true;
      }
    } else {
      signalForDownloadDecision = true;
    }

    const decisionAttachmentList = [this.props.decisionAttachment];
    const referenceNumberUpdate = (
      <InputField
        placeholder={Placeholders.referenceNumber}
        value={referenceNumber}
        disabled
      />
    );

    const decisionStatusInfo = (
      <InputField
        placeholder={Placeholders.decisionStatus}
        value={decisionStatus}
      />
    );

    const statusInfo = (
      <InputField placeholder={Placeholders.status} value={status} />
    );

    const editButtonStyle =
      requestForSignetApproval.status === 'REQUIRED_COMPLEMENTATION'
        ? 'fas fa-edit fa-2x red-color ml-3'
        : 'fas fa-edit fa-2x';

    const decisionCreationDate =
      decision?.dateCreated && formatDate(decision?.dateCreated);
    const elColumnStyle = decision?.dateCreated ? 5 : 12;

    const attachmentExist = requestForSignetApprovalAttachmentList?.length > 0;
    const decisionTableColStyle = !attachmentExist && 'mt-5';
    const statusRevertText = this.props.decision?.id
      ? Tooltips.decisionStatusRevert
      : Tooltips.requestStatusRevert;

    const requestForSignetApprovalData = (
      <Row style={{ marginTop: '-20px' }}>
        <Col md={4}>
          <InputField
            name="place"
            placeholder={Placeholders.place}
            value={place?.name}
            disabled
          />
          <InputField
            name="municipality"
            placeholder={Placeholders.municipality}
            value={municipality?.name}
            disabled
          />

          <InputField
            name="kjs"
            placeholder={Placeholders.kjs}
            value={kjs?.name}
            disabled
            multiline
            rows={2}
          />

          <InputField
            name="countryName"
            placeholder={Placeholders.countryName}
            value={'Република Србија'}
            disabled
          />
          {municipality?.place?.autonomousProvince && (
            <InputField
              name="autonomousProvince"
              placeholder={Placeholders.autonomousProvince}
              value={
                autonomousProvinces[municipality?.place?.autonomousProvince]
                  ?.text
              }
              disabled
            />
          )}
        </Col>
        <Col md={8}>
          <Row md={12}>
            <Col md={6}>
              <Row md={12}>
                <Col md={6}>
                  <InputField
                    name="pib"
                    placeholder={Placeholders.pib}
                    value={pib}
                    disabled
                  />
                </Col>
                <Col md={6}>
                  <InputField
                    name="identificationNumber"
                    placeholder={Placeholders.identificationNumber}
                    value={identificationNumber}
                    disabled
                  />
                </Col>
              </Row>

              <InputField
                name="uniqueNumber"
                placeholder={Placeholders.uniqueNumber}
                value={uniqueNumber}
                disabled
              />

              <InputField
                name="organizationalUnit"
                placeholder={Placeholders.organizationalUnit}
                value={fullOrganizationUnit}
                disabled
                multiline
                rows={2}
              />
              {nationalMinoritiesTranslate?.length > 0 && (
                <InputField
                  name="nationalMinorities"
                  placeholder={Placeholders.nationalMinorities}
                  value={nationalMinoritiesTranslate}
                  multiline
                  rows={1}
                  disabled
                />
              )}
            </Col>

            <Col md={6}>
              <Row>
                <Col md={5}>
                  <InputField
                    name="numberOfSignets"
                    placeholder={Placeholders.numberOfSignets}
                    value={numberOfSignets}
                    disabled
                  />
                </Col>
                <Col md={7}>
                  <InputField
                    name="submitDateFormat"
                    placeholder={Placeholders.date}
                    value={submitDateFormat}
                    disabled
                  />
                </Col>
              </Row>
              <Row>
                <Col md={elColumnStyle}>
                  <InputField
                    name="signetForm"
                    placeholder={Placeholders.signetForm}
                    value={isElSignetText}
                    disabled
                  />
                </Col>
                {decisionCreationDate && (
                  <Col md={7}>
                    <InputField
                      name="decisionCreationDate"
                      placeholder={Placeholders.decisionCreationDate}
                      value={decisionCreationDate}
                      disabled
                    />
                  </Col>
                )}
              </Row>
              <InputField
                name="coatOfArmsAppearance"
                placeholder={Placeholders.coatOfArmsAppearance}
                value={coatOfArmsAppearanceText}
                disabled
                multiline
                rows={2}
              />
              {note && (
                <InputField
                  name="note"
                  placeholder={Placeholders.note}
                  value={note}
                  multiline
                  rows={4}
                  disabled
                />
              )}
            </Col>
          </Row>
        </Col>

        {!isPreview && (
          <Col md={5} className="mt-5">
            <Card>
              <Card.Header>
                <Card.Title as="h5">
                  {this.props.t.Labels.actionTitle}
                </Card.Title>
              </Card.Header>
              <Card.Body>
                <Row>
                  {isRequestDownloadAllowed && (
                    <ActionButton
                      actionMessage={Tooltips.downloadRequest}
                      action={this.handleDownloadRequest}
                      icon={
                        <CloudDownloadOutlinedIcon
                          fontSize="large"
                          className="m-auto"
                          style={{ color: '#203a5d' }}
                        />
                      }
                    />
                  )}
                  {isActionUpdateAllowed && (
                    <ActionButton
                      actionMessage={Tooltips.edit}
                      action={() => this.showModal(1)}
                      icon={<i className={editButtonStyle}></i>}
                    />
                  )}
                  {isComplementationContentAllowed && (
                    <ActionButton
                      actionMessage={Tooltips.complementRequiredContent}
                      action={() => this.showModal(8)}
                      icon={
                        <AssignmentLateOutlinedIcon
                          className="red-color"
                          fontSize="large"
                        />
                      }
                    />
                  )}
                  {isActionUpdateAllowed &&
                    requestForSignetApproval.status ===
                      'REQUIRED_COMPLEMENTATION' && (
                      <ActionButton
                        actionMessage={Tooltips.saveEdit}
                        action={this.acceptEdit}
                        icon={
                          <DoneIcon
                            fontSize="large"
                            style={{ color: '#203a5d' }}
                          />
                        }
                      />
                    )}
                  {isActionAddProcessorAllowed && (
                    <ActionButton
                      actionMessage={Tooltips.addProccesor}
                      action={() => this.addProcessorRequest()}
                      icon={
                        <PersonAddIcon
                          fontSize="large"
                          style={{ color: '#203a5d' }}
                        />
                      }
                    />
                  )}
                  {isReferenceNumberAllowed && (
                    <ActionButton
                      actionMessage={
                        this.props.requestForSignetApproval
                          .requestForSignetApproval.referenceNumber
                          ? Tooltips.updateReferenceNumber
                          : Tooltips.createReferenceNumber
                      }
                      action={() => this.showModal(5)}
                      icon={
                        <i
                          className="fas fa-pen fa-2x"
                          style={{ marginLeft: '15px' }}
                        />
                      }
                    />
                  )}
                  {isActionRequestComplementationAllowed && (
                    <ActionButton
                      actionMessage={Tooltips.complementRequired}
                      action={() => this.showModal(3)}
                      icon={
                        <NoteAddIcon
                          fontSize="large"
                          style={{ color: '#203a5d' }}
                        />
                      }
                    />
                  )}
                  {isActionAcceptAllowed && (
                    <ActionButton
                      actionMessage={Tooltips.accept}
                      action={this.acceptRequest}
                      icon={
                        <DoneOutlineIcon
                          fontSize="large"
                          style={{ color: '#203a5d' }}
                        />
                      }
                    />
                  )}
                  <ActionButton
                    actionMessage={Tooltips.complementationHistory}
                    action={() => this.showModal(9)}
                    icon={
                      <HistoryRoundedIcon
                        fontSize="large"
                        style={{ color: '#203a5d' }}
                      />
                    }
                  />
                  {isDecisionViewAllowed && (
                    <Fragment>
                      {isDecisionUploadAllowed && (
                        <ActionButton
                          actionMessage={Tooltips.downloadProposalSolutiоn}
                          action={this.downloadProposedSolutiоn}
                          icon={
                            <GetAppIcon
                              fontSize="large"
                              style={{ color: '#203a5d' }}
                            />
                          }
                        />
                      )}
                      {isDecisionUploadAllowed && (
                        <ActionButton
                          actionMessage={Tooltips.uploadDecision}
                          action={() => this.showModal(2)}
                          icon={
                            <BackupIcon
                              fontSize="large"
                              style={{ color: '#203a5d' }}
                            />
                          }
                        />
                      )}
                      {isDecisionAcceptAllowed && (
                        <ActionButton
                          actionMessage={Tooltips.verifeidDecision}
                          action={() =>
                            this.handleDecisionStatusChange(
                              decisionStatuses.VERIFIED.text,
                              ConfirmDialog.confirmMessageVerified,
                              ConfirmDialog.confirmDeleteVerified
                            )
                          }
                          icon={
                            <DoneAllIcon
                              fontSize="large"
                              style={{ color: '#203a5d' }}
                            />
                          }
                        />
                      )}
                      {isDecisionSentAllowed && (
                        <ActionButton
                          actionMessage={Tooltips.sendDecision}
                          action={() =>
                            this.handleSendDecisionToRobon(
                              ConfirmDialog.confirmMessageSend,
                              ConfirmDialog.confirmDeleteSend
                            )
                          }
                          icon={
                            <SendIcon
                              fontSize="large"
                              style={{ color: '#203a5d' }}
                            />
                          }
                        />
                      )}
                      {isStatusRevertAllowed && (
                        <ActionButton
                          actionMessage={statusRevertText}
                          action={this.handleStatusRevert}
                          icon={
                            <SyncIcon
                              fontSize="large"
                              style={{ color: '#203a5d' }}
                            />
                          }
                        />
                      )}
                    </Fragment>
                  )}
                  {isActionUpdateRequestCreatorAllowed && (
                    <ActionButton
                      actionMessage={Tooltips.requestCreatorEdit}
                      action={() => this.showModal(10)}
                      icon={
                        <i
                          className="fas fa-user-edit fa-2x"
                          style={{ marginLeft: '15px' }}
                        ></i>
                      }
                    />
                  )}
                </Row>
              </Card.Body>
            </Card>
          </Col>
        )}
        {attachmentExist && (
          <Col md={!isPreview ? 7 : 12} className="mt-5">
            <Card>
              <Card.Header>
                <Card.Title as="h5">
                  {this.props.t.Labels.documentTitle}
                </Card.Title>
              </Card.Header>
              <Card.Body style={{ marginTop: '-30px' }}>
                <AttachmentTable
                  attachments={requestForSignetApprovalAttachmentList}
                  handleDownload={downloadAttachment}
                  controllerReference={'requestForSignetApprovalAttachment'}
                />
              </Card.Body>
            </Card>
          </Col>
        )}
        {Object.keys(this.props.decisionAttachment.length !== 0) &&
          (isPreview
            ? signalForDownloadDecision
            : isPreview || isDecisionDownloadAllowed) && (
            <Col
              md={!isPreview ? 7 : 12}
              className={`ml-auto ${decisionTableColStyle}`}
            >
              <Card>
                <Card.Header>
                  <Card.Title as="h5">
                    {this.props.t.Labels.decisionTitle}
                  </Card.Title>
                </Card.Header>
                <Card.Body style={{ marginTop: '-30px' }}>
                  <AttachmentTable
                    attachments={decisionAttachmentList}
                    handleDownload={this.downloadDecision}
                    controllerReference={'decisionAttachment'}
                  />
                </Card.Body>
              </Card>
            </Col>
          )}
      </Row>
    );

    const pageContentWrapperStyle = !isPreview && 'col-md-11 m-auto';
    const pageContent = (
      <div className={`${pageContentWrapperStyle}`}>
        <div>
          <Row>
            <Col md={12}>
              <Card className="mt-5">
                <Card.Header>
                  <Row>
                    {!isPreview && (
                      <Col md={5}>
                        <Card.Title as="h5">
                          {this.props.t.Labels.title}
                        </Card.Title>
                      </Col>
                    )}
                    <Col className="text-center">
                      <Card.Title className="row align-items-center">
                        <Col
                          md={!isPreview ? 4 : 4}
                          disabled
                          className="preview-style ml-auto"
                        >
                          {statusInfo}
                        </Col>
                        {decisionStatus && (
                          <Col
                            md={!isPreview ? 3 : 4}
                            disabled
                            className="preview-style"
                          >
                            {decisionStatusInfo}
                          </Col>
                        )}
                        {referenceNumber && (
                          <Col md={!isPreview ? 5 : 4}>
                            {referenceNumberUpdate}
                          </Col>
                        )}
                      </Card.Title>
                    </Col>
                  </Row>
                </Card.Header>
                <Card.Body>{requestForSignetApprovalData}</Card.Body>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    );

    return (
      <Fragment>
        {pageContent}
        {this.state.showUpdate && (
          <ModalForRequestForSignetApprovalUpdateAndPreview
            handleAdd={this.handleAdd}
            show={this.state.showUpdate}
            requestForSignetApproval={requestForSignetApproval}
            handleClose={this.handlePreviewClose}
            error={error}
            deleteError={deleteErrorRequestForSignetApproval}
            isPreview={this.state.showPreview}
            requestForSignetApprovalAttachmentList={
              requestForSignetApprovalAttachmentList
            }
          />
        )}
        {this.state.showDecisionCreation && (
          <ModalForAddDecision
            handleAdd={this.handleAddDecision}
            handleClose={this.handlePreviewClose}
            show={this.state.showDecisionCreation}
            error={errorDecision}
            deleteError={deleteErrorRequestForSignetApproval}
            handleAddDecisionWithAttachment={
              this.handleAddDecisionWithAttachment
            }
            findAllDecisionTypes={findAllDecisionTypes}
            decisionTypeList={decisionTypeList}
            requestForSignetApprovalId={requestForSignetApproval?.id}
            decision={this.props.decision}
          />
        )}
        {this.state.showComplementRequest && (
          <ModalForAddComplementRequestApproval
            handleAdd={this.handleAddComplementRequestApproval}
            handleClose={this.handlePreviewClose}
            show={this.state.showComplementRequest}
            requestForSignetApproval={requestForSignetApproval}
            createComplementRequestApproval={createComplementRequestApproval}
            loggedUser={loggedUser}
            error={errorComplement}
          />
        )}
        {this.state.showCreateReferenceNumber && (
          <ModalForCreateRequestApprovalReferenceNumber
            handleAdd={this.handleCreateRequestApprovalReferenceNumber}
            handleClose={this.handlePreviewClose}
            show={this.state.showCreateReferenceNumber}
            requestForSignetApproval={requestForSignetApproval}
            createRequestForSignetApprovalReferenceNumber={
              createRequestForSignetApprovalReferenceNumber
            }
            error={error}
            deleteErrorRequestForSignetApproval={
              deleteErrorRequestForSignetApproval
            }
          />
        )}
        {this.state.showUpdateReferenceNumber && (
          <ModalForUpdateRequestApprovalReferenceNumber
            handleAdd={this.handleCreateRequestApprovalReferenceNumber}
            handleClose={this.handlePreviewClose}
            show={this.state.showUpdateReferenceNumber}
            requestForSignetApproval={requestForSignetApproval}
            createRequestForSignetApprovalReferenceNumber={
              createRequestForSignetApprovalReferenceNumber
            }
          />
        )}
        {this.state.showComplementRequestDesc && (
          <ModalForAddComplementRequestApproval
            handleAdd={this.handleAddComplementRequestApproval}
            handleClose={this.handlePreviewClose}
            show={this.state.showComplementRequestDesc}
            requestForSignetApproval={requestForSignetApproval}
            complementRequestApproval={this.props.complementRequestApproval}
            signal={true}
            findLastComplementRequestApprovalByRequestId={
              this.props.findLastComplementRequestApprovalByRequestId
            }
          />
        )}
        {this.state.showComplementRequestHistory && (
          <ModalForViewComplementRequestHistory
            show={this.state.showComplementRequestHistory}
            handleClose={this.handlePreviewClose}
            complementRequestApprovalList={complementRequestApprovalList}
          />
        )}
        {this.state.showUpdateOfRequestCreator && (
          <ModalForUpdateRequestCreator
            show={this.state.showUpdateOfRequestCreator}
            handleClose={this.handlePreviewClose}
            usersByKJSMunicipality={userList}
            handleRequestUpdate={this.requestCreatorUpdateSubmit}
            currentRequestClient={client}
            requestForSignetApproval={requestForSignetApproval}
          />
        )}
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  requestForSignetApproval: state.requestForSignetApproval,
  requestForSignetApprovalAttachmentList:
    state.requestForSignetApproval.requestForSignetApprovalAttachmentList || [],
  isLoadingNeeded: state.requestForSignetApproval.loading,
  loggedUser: state.loggedUser,
  decisionTypeList: state.decisionType.decisionTypeList,
  errorDecision: state.decision.error,
  userAllowedActionsList: state.user.userAllowedActionsList || [],
  userList: state.user.userList || [],
  decision: state.decision.decision,
  decisionAttachment: state.decisionAttachment.decisionAttachment,
  complementRequestApproval:
    state.complementRequestApproval.complementRequestApproval,
  complementRequestApprovalList:
    state.complementRequestApproval.complementRequestApprovalList,
  errorComplement: state.complementRequestApproval.error,
});

const mapDispatchToProps = (dispatch) => {
  return {
    findRequestForSignetApprovalById: (id) => {
      dispatch(findRequestForSignetApprovalById(id));
    },
    addProcessorRequestForSignetApproval: (referenceId, callback, message) => {
      dispatch(
        addProcessorRequestForSignetApproval(referenceId, callback, message)
      );
    },
    createRequestForSignetApproval: (
      requestForSignetApproval,
      callback,
      createNotification,
      message
    ) => {
      dispatch(
        createRequestForSignetApproval(
          requestForSignetApproval,
          callback,
          createNotification,
          message
        )
      );
    },
    findAllDecisionTypes: () => {
      dispatch(findAllDecisionTypes());
    },
    createDecision: (decision, callback, messages) => {
      dispatch(createDecision(decision, callback, messages));
    },
    deleteErrorDecision: () => {
      dispatch(deleteErrorDecision());
    },
    deleteErrorRequestForSignetApproval: () => {
      dispatch(deleteErrorRequestForSignetApproval());
    },
    findAllRequestForSignetApprovalAttachments: (
      requestForSignetApprovalId
    ) => {
      dispatch(
        findAllRequestForSignetApprovalAttachments(requestForSignetApprovalId)
      );
    },
    downloadAttachment: (uuidDocName, documentName) => {
      dispatch(downloadAttachment(uuidDocName, documentName));
    },
    createComplementRequestApproval: (
      complementRequestApproval,
      callback,
      message
    ) => {
      dispatch(
        createComplementRequestApproval(
          complementRequestApproval,
          callback,
          message
        )
      );
    },
    downloadProposalSolution: (requestForSignetApproval, message) => {
      dispatch(downloadProposalSolution(requestForSignetApproval, message));
    },
    downloadRequest: (requestForSignetApprovalId, message) => {
      dispatch(downloadRequest(requestForSignetApprovalId, message));
    },
    createRequestForSignetApprovalReferenceNumber: (
      id,
      referenceNumber,
      callback,
      createNotification,
      messages
    ) => {
      dispatch(
        createRequestForSignetApprovalReferenceNumber(
          id,
          referenceNumber,
          callback,
          createNotification,
          messages
        )
      );
    },
    findAllUserAllowedActions: (
      requestForSignetApprovalId,
      controllerReference
    ) => {
      dispatch(
        findAllUserAllowedActions(
          requestForSignetApprovalId,
          controllerReference
        )
      );
    },
    createDecisionWithAttachment: (decision, idReq, callback, message) => {
      dispatch(
        createDecisionWithAttachment(decision, idReq, callback, message)
      );
    },
    changeRequestForSignetApprovalStatus: (id, status, callback, message) => {
      dispatch(
        changeRequestForSignetApprovalStatus(id, status, callback, message)
      );
    },
    findDecisionByRequestId: (id) => {
      dispatch(findDecisionByRequestId(id));
    },
    findDecisionAttachmentByDecision: (decisionId) => {
      dispatch(findDecisionAttachmentByDecision(decisionId));
    },
    downloadDecisionAttachment: (uuidDocName, decisionName, message) => {
      dispatch(downloadDecisionAttachment(uuidDocName, decisionName, message));
    },
    changeDecisionStatusWithStatus: (id, status, callback, message) => {
      dispatch(changeDecisionStatusWithStatus(id, status, callback, message));
    },
    sendDecisionToRobon: (id, callback, message) => {
      dispatch(sendDecisionToRobon(id, callback, message));
    },
    findLastComplementRequestApprovalByRequestId: (id) => {
      dispatch(findLastComplementRequestApprovalByRequestId(id));
    },
    findAllComplementRequestsByRequestId: (id) => {
      dispatch(findAllComplementRequestsByRequestId(id));
    },
    clearComplementRequestApproval: () => {
      dispatch(clearComplementRequestApproval());
    },
    findAllUsersByKJSMunicipality: (kjsMunicipalityId) => {
      dispatch(findAllUsersByKJSMunicipality(kjsMunicipalityId));
    },
    removeUserList: () => {
      dispatch(removeUserList());
    },
    updateRequestClient: (
      requestForSignetApproval,
      callback,
      messages,
      callback2
    ) => {
      dispatch(
        updateRequestClient(
          requestForSignetApproval,
          callback,
          messages,
          callback2
        )
      );
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withTranslations(
    RequestForSignetApprovalProcessingView,
    'RequestForSignetApprovalProcessingView'
  )
);
